export const callbackPath = '/pipedrive-assistant';
export const returnToKey = (uid: string) => `pipedrive-return-to:${uid}`;

export function consumeReturnTo(uid: string) {
  const value = sessionStorage.getItem(returnToKey(uid));
  sessionStorage.removeItem(returnToKey(uid));
  if (!value) return '/groups';
  try {
    const url = new URL(value, window.location.origin);
    // Only return to app pages, never another origin or back into OAuth handling.
    if (
      url.origin !== window.location.origin ||
      url.pathname === callbackPath ||
      !value.startsWith('/')
    )
      return '/groups';
    return url.pathname + url.search + url.hash;
  } catch {
    return '/groups';
  }
}
